import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import BreadCrumb from 'components/Common/BreadCrumb';
import DropdownOption from 'components/Common/DropdownOption';
import LabelWrapper from 'components/Common/LabelWrapper';
import { useRole } from 'components/Hooks/UserHooks';
import { useFormik } from "formik";
import { AI_MODEL_BOOSTING_NEWS_TRAVEL_OPTIONS, SYSTEM_CONFIG_KEY } from 'helpers/constans';
import { isHavePermissionRole, ROLES_FOR_APP } from 'helpers/role';
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Card, CardBody, Col, Container, Input, Label, Modal, ModalBody, ModalHeader, Row, Spinner } from "reactstrap";
import { getConfiguration, putConfiguration } from 'store/thunks';
import * as Yup from "yup";

const Configuration = () => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();

  const AI_MODEL_BOOSTING_NEWS_TRAVEL_OPTIONS_LANG: any = AI_MODEL_BOOSTING_NEWS_TRAVEL_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleSubmit = async (values: any) => {
    if (isLoading) {
      return;
    }
    setIsOpen((_prev) => true);
  };

  const handleSubmitConfiguration = async (values: any) => {
    try {
      if (isLoading) {
        return;
      }

      setIsLoading((_prev) => true);

      const _data_configs = {
        configs: [
          {
            key: SYSTEM_CONFIG_KEY.TRAVEL_NEWS_GENERATE_PROMPT,
            value: String(values?.generate_prompt ?? ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.TRAVEL_NEWS_GENERATE_AI_MODEL,
            value: String(values?.ai_model?.value ?? ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.TRAVEL_NEWS_TOP_PERCENTAGE_RANDOM_SELECTION,
            value: String(values?.top_percentage_random_selection ?? ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.TRAVEL_NEWS_RANDOM_SELECTION_COUNT,
            value: String(values?.random_selection_count ?? ''),
            is_active: 1,
          },
          {
            key: SYSTEM_CONFIG_KEY.TRAVEL_NEWS_BLOCKED_PLACES,
            value: String(values?.blocked_places ?? ''),
            is_active: 1,
          },
                              {
                                  key: SYSTEM_CONFIG_KEY.TRAVEL_NEWS_SELECTION_RATIO,
                                  value: JSON.stringify({
                                      attraction: String(values?.attraction_count)?.trim() === '' ? null :  Number(values?.attraction_count || 0),
                                      food: String(values?.food_count)?.trim() === '' ? null :  Number(values?.food_count || 0),
                                      cafe: String(values?.cafe_count)?.trim() === '' ? null :  Number(values?.cafe_count || 0),
                                  }),
                                  is_active: 1,
                              },
        ]
      };

      const [res1]: any = await Promise.all([putConfiguration(_data_configs)]);
      setIsOpen((_prev) => false);
      setIsLoading((_prev) => false);
      if (res1?.code === 200) {
        toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
      } else {
        toast(`${res1?.message || res1}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsOpen((_prev) => false);
      setIsLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const validationSchema = Yup.object({
    generate_prompt: Yup.string().nullable(),
    ai_model: Yup.object().shape({
      label: Yup.string(),
      value: Yup.string(),
    }).nullable(),
    top_percentage_random_selection: Yup.string().nullable(),
    random_selection_count: Yup.string().nullable(),
    blocked_places: Yup.string().nullable(),
    attraction_count: Yup.string().nullable(),
    food_count: Yup.string().nullable(),
    cafe_count: Yup.string().nullable(),
  });

  const formik = useFormik({
    initialValues: {
      generate_prompt: '',
      ai_model: AI_MODEL_BOOSTING_NEWS_TRAVEL_OPTIONS_LANG[0],
      top_percentage_random_selection: '',
      random_selection_count: '',
      blocked_places: '',
      attraction_count: '',
      food_count: '',
      cafe_count: '',
    },
    validationSchema,
    onSubmit: handleSubmit,
  });

  const handleCallAllOption = async () => {
    try {
      const [res1]: any = await Promise.all([getConfiguration({})]);

      const _configs = res1?.data?.list || [];

       const _config_ratio = JSON.parse(_configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.TRAVEL_NEWS_SELECTION_RATIO)?.value || '{}');

      const _config_generate_prompt = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.TRAVEL_NEWS_GENERATE_PROMPT) || {};
      const _config_ai_model = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.TRAVEL_NEWS_GENERATE_AI_MODEL) || {};
      const _config_top_percentage_random_selection = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.TRAVEL_NEWS_TOP_PERCENTAGE_RANDOM_SELECTION) || {};
      const _config_random_selection_count = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.TRAVEL_NEWS_RANDOM_SELECTION_COUNT) || {};
      const _config_blocked_places = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.TRAVEL_NEWS_BLOCKED_PLACES) || {};
       const _config_attraction_count = _config_ratio?.attraction !== null ? _config_ratio?.attraction : '';
      const _config_food_count = _config_ratio?.food !== null ? _config_ratio?.food : '';
      const _config_cafe_count = _config_ratio?.cafe !== null ? _config_ratio?.cafe : '';
      formik?.setFieldValue('generate_prompt', _config_generate_prompt?.value);
      formik?.setFieldValue('ai_model', AI_MODEL_BOOSTING_NEWS_TRAVEL_OPTIONS_LANG?.find((item: any) => item?.value === _config_ai_model?.value) || null);
      formik?.setFieldValue('top_percentage_random_selection', _config_top_percentage_random_selection?.value);
      formik?.setFieldValue('random_selection_count', _config_random_selection_count?.value);
      formik?.setFieldValue('blocked_places', _config_blocked_places?.value);
      formik?.setFieldValue('attraction_count', _config_attraction_count);
      formik?.setFieldValue('food_count', _config_food_count);
      formik?.setFieldValue('cafe_count', _config_cafe_count);
    } catch (error: any) {
      return error;
    }
  };

  useEffect(() => {
    handleCallAllOption();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    document.title = `${t('Configuration')} - ${t('Boosting News Travel')} | PRESS Ai`;
    document.body.classList.remove('vertical-sidebar-enable');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t('Boosting News Travel')} pageTitle={t('Configuration')} />
          <Row>
            {isHavePermissionRole(ROLES_FOR_APP.CONFIGURATION_BOOSTING_NEWS_TRAVEL, userPermissions) && (
              <Col lg={12}>
                <Card id="customerList" style={{ boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.03)', minHeight: '75dvh' }}>
                  <CardBody className="pt-3 mx-3">
                    <form onSubmit={formik.handleSubmit}>
                      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
                        <div className="position-relative mb-3 mt-1 mt-md-0" style={{ border: '1px dashed var(--vz-primary)', borderRadius: '4px', padding: '10px' }}>
                          <span className="text-primary position-absolute fs-13 px-1" style={{ backgroundColor: "var(--vz-secondary-bg)", top: '0px', transform: 'translateY(-50%)' }}>{t('Boosting News Travel')}</span>
                          <Row className='px-2'>
                            <Col sm={12} md={12} xl={12} className='mt-2 mb-2'>
                              <Label htmlFor="ai_model" className="form-label">{t('AI Model')}</Label> <span className="text-danger"> *</span>
                              <DropdownOption
                                name="ai_model"
                                dataList={AI_MODEL_BOOSTING_NEWS_TRAVEL_OPTIONS_LANG || []}
                                placeholder={`${t("AI Model")}...`}
                                className={`dropdown-status-rounded z-hight mb-3 mb-lg-2 mb-xxl-1`}
                                classNamePrefix="name-prefix"
                                style={{ width: '100%' }}
                                initialValue={formik?.values?.ai_model}
                                onChangeSelect={(e: any) => {
                                  formik.setFieldValue("ai_model", e);
                                }}
                              />
                            </Col>

                            <Col sm={12} md={12} xl={12} className='mt-2 '>
                              <Label htmlFor="generate_prompt" className="form-label">{t('Generate Prompt')} <span className="text-danger"> *</span></Label>
                              <Input
                                className="form-control"
                                id="generate_prompt"
                                name="generate_prompt"
                                type="textarea"
                                autoComplete='off'
                                rows={10}
                                value={formik?.values?.generate_prompt || ''}
                                placeholder={t('Generate Prompt')}
                                onChange={(e: any) => {
                                  formik?.setFieldValue('generate_prompt', e?.target?.value || '');
                                }}
                              />
                              {formik.touched.generate_prompt && formik.errors.generate_prompt ? (
                                <div className="text-danger mt-2">{formik.errors.generate_prompt}</div>
                              ) : null}
                            </Col>
                            <Label htmlFor="from_percentage" className="form-label mt-4">{t('Percentage for Random Selection')} <span className="text-danger"> *</span></Label>
                            <div className='position-relative  mt-0' >
                              <div className='border border-dashed rounded-3 p-3 pt-4 d-flex align-items-center justify-content-between' style={{ borderColor: "var(--vz-secondary)!important" }}>
                                <div className='w-100 position-relative'>
                                  <LabelWrapper label={t('From Percentage')} isShow={true}>
                                    <Input
                                      id="from_percentage"
                                      name="from_percentage"
                                      type="number"
                                      className="form-control mb-3 mb-lg-2 mb-xxl-1"
                                      placeholder=""
                                      value={formik?.values?.top_percentage_random_selection?.split('-')?.[0] || ''}
                                      onChange={(event: any) => {
                                        const input = event.target.value;
                                        const onlyNumbers = String(input).replace(/\D/g, '');
                                        formik?.setFieldValue('top_percentage_random_selection', `${onlyNumbers}-${formik?.values?.top_percentage_random_selection?.split('-')?.[1] || ''}`);
                                      }}
                                    />
                                  </LabelWrapper>
                                  <span className='text-muted fs-12 position-absolute' style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }}>%</span>
                                </div>
                                <div className='text-center px-2'>~</div>
                                <div className='w-100 position-relative'>
                                  <LabelWrapper label={t('To Percentage')} isShow={true}>
                                    <Input
                                      name="to_percentage"
                                      type="number"
                                      className="form-control mb-3 mb-lg-2 mb-xxl-1"
                                      placeholder=""
                                      value={formik?.values?.top_percentage_random_selection?.split('-')?.[1] || ''}
                                      onChange={(event: any) => {
                                        const input = event.target.value;
                                        const onlyNumbers = String(input).replace(/\D/g, '');
                                        formik?.setFieldValue('top_percentage_random_selection', `${formik?.values?.top_percentage_random_selection?.split('-')?.[0] || ''}-${onlyNumbers}`);
                                      }}
                                    />
                                  </LabelWrapper>
                                  <span className='text-muted fs-12 position-absolute' style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }}>%</span>
                                </div>
                              </div>
                            </div>
                            <Label htmlFor="from_count" className="form-label mt-4">{t('Random Selection Count')} <span className="text-danger"> *</span></Label>
                            <div className='position-relative  mt-0' >
                              <div className='border border-dashed rounded-3 p-3 pt-4 d-flex align-items-center justify-content-between' style={{ borderColor: "var(--vz-secondary)!important" }}>
                                <div className='w-100 position-relative'>
                                  <LabelWrapper label={t('From Count')} isShow={true}>
                                    <Input
                                      name="from_count"
                                      type="number"
                                      className="form-control mb-3 mb-lg-2 mb-xxl-1"
                                      placeholder=""
                                      value={formik?.values?.random_selection_count?.split('-')?.[0] || ''}
                                      onChange={(event: any) => {
                                        const input = event.target.value;
                                        const onlyNumbers = String(input).replace(/\D/g, '');
                                        formik?.setFieldValue('random_selection_count', `${onlyNumbers}-${formik?.values?.random_selection_count?.split('-')?.[1] || ''}`);
                                      }}
                                    />
                                  </LabelWrapper>
                                  <span className='text-muted fs-12 position-absolute' style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }}>{t('Places')}</span>
                                </div>
                                <div className='text-center px-2'>~</div>
                                <div className='w-100 position-relative'>
                                  <LabelWrapper label={t('To Count')} isShow={true}>
                                    <Input
                                      name="to_count"
                                      type="number"
                                      className="form-control mb-3 mb-lg-2 mb-xxl-1"
                                      placeholder=""
                                      value={formik?.values?.random_selection_count?.split('-')?.[1] || ''}
                                      onChange={(event: any) => {
                                        const input = event.target.value;
                                        const onlyNumbers = String(input).replace(/\D/g, '');
                                        formik?.setFieldValue('random_selection_count', `${formik?.values?.random_selection_count?.split('-')?.[0] || ''}-${onlyNumbers}`);
                                      }}
                                    />
                                  </LabelWrapper>
                                  <span className='text-muted fs-12 position-absolute' style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }}>{t('Places')}</span>
                                </div>
                              </div>
                            </div>
                            <Label htmlFor="from_count" className="form-label mt-4">{t('Random Type Count')} <span className="text-danger"> *</span></Label>
                            <div className='position-relative  mt-0' >
                              <div className='border border-dashed rounded-3 p-3 pt-4 d-flex align-items-center justify-content-between' style={{ borderColor: "var(--vz-secondary)!important" }}>
                                <div className='w-100 position-relative'>
                                  <LabelWrapper label={t('Attraction')} isShow={true}>
                                    <Input
                                      name="attraction_count"
                                      type="number"
                                      className="form-control mb-3 mb-lg-2 mb-xxl-1"
                                      placeholder=""
                                      value={formik?.values?.attraction_count}
                                      onChange={(event: any) => {
                                        const input = event.target.value;
                                        const onlyNumbers = String(input).replace(/\D/g, '');
                                        formik?.setFieldValue('attraction_count', `${onlyNumbers}`);
                                      }}
                                    />
                                  </LabelWrapper>
                                  <span className='text-muted fs-12 position-absolute' style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }}>{t('Places')}</span>
                                </div>
                                <div className='text-center px-2'>|</div>
                                <div className='w-100 position-relative'>
                                  <LabelWrapper label={t('Food')} isShow={true}>
                                    <Input
                                      name="food_count"
                                      type="number"
                                      className="form-control mb-3 mb-lg-2 mb-xxl-1"
                                      placeholder=""
                                      value={formik?.values?.food_count}
                                      onChange={(event: any) => {
                                        const input = event.target.value;
                                        const onlyNumbers = String(input).replace(/\D/g, '');
                                        formik?.setFieldValue('food_count', `${onlyNumbers}`);
                                      }}
                                    />
                                  </LabelWrapper>
                                  <span className='text-muted fs-12 position-absolute' style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }}>{t('Places')}</span>
                                </div>
                                <div className='text-center px-2'>|</div>
                                <div className='w-100 position-relative'>
                                  <LabelWrapper label={t('Cafe')} isShow={true}>
                                    <Input
                                      name="cafe_count"
                                      type="number"
                                      className="form-control mb-3 mb-lg-2 mb-xxl-1"
                                      placeholder=""
                                      value={formik?.values?.cafe_count}
                                      onChange={(event: any) => {
                                        const input = event.target.value;
                                        const onlyNumbers = String(input).replace(/\D/g, '');
                                        formik?.setFieldValue('cafe_count', `${onlyNumbers}`);
                                      }}
                                    />
                                  </LabelWrapper>
                                  <span className='text-muted fs-12 position-absolute' style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }}>{t('Places')}</span>
                                </div>
                              </div>
                            </div>
                            <Col sm={12} md={12} xl={12} className='mt-3'>
                              <Label htmlFor="blocked_places" className="form-label">{t('Blocked Places')} <span className="text-danger"> *</span></Label>
                              <Input
                                className="form-control"
                                id="blocked_places"
                                name="blocked_places"
                                type="textarea"
                                autoComplete='off'
                                rows={10}
                                value={formik?.values?.blocked_places || ''}
                                placeholder={t('Blocked Places')}
                                onChange={(e: any) => {
                                  formik?.setFieldValue('blocked_places', e?.target?.value || '');
                                }}
                              />
                            </Col>

                            <Col sm={12} md={12} xl={12} className='mt-4 mb-3 pt-1 text-end'>
                              <button
                                style={{ width: '150px' }}
                                type="submit"
                                disabled={(isLoading)}
                                className="btn btn-primary fs-14 rounded-pill">
                                {<>{t('Button Update')}</>}
                              </button>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </form>
                  </CardBody>
                </Card>
              </Col>
            )}
          </Row>
        </Container>

        <Modal
          isOpen={!!isOpen}
          centered={true}
          // size="lg"
          toggle={() => setIsOpen(false)}
          keyboard={true}
        >
          <ModalHeader>
            {t('Configuration')}
          </ModalHeader>

          <ModalBody className="">
            <div className="row g-4">
              <Col sm={12}>
                <div className="row g-3">
                  <div className="mt-3 text-center">
                    <h6 className="mb-2 fs-19 text-center mt-1">
                      {t("Are you sure you want to update this?")}
                    </h6>
                    <p className="fs-15 mb-4 d-flex justify-content-center align-items-start align-items-sm-center text-center ">
                      {t('After confirming the update action, the data will be updated. Do you want to proceed with the update action.')}
                    </p>
                    <div className="d-flex gap-3 mt-2 justify-content-center">
                      <button
                        className="btn btn-primary rounded-pill fs-14"
                        type="button"
                        color="light"
                        onClick={() => handleSubmitConfiguration(formik?.values)}
                        style={{ width: '120px' }}
                      >
                        {(isLoading) ? <Spinner size="sm me-2" ></Spinner> : <>{t('Button Update')}</>}
                      </button>
                      <button
                        className="btn btn-secondary rounded-pill fs-14 ms-2"
                        type="button"
                        color="light"
                        onClick={() => setIsOpen(false)}
                        style={{ width: '120px' }}
                      >
                        {t("Button Close")}
                      </button>
                    </div>
                  </div>
                </div>
              </Col>
            </div>
          </ModalBody>
        </Modal >

        <ToastContainer closeButton={false} newestOnTop={false} pauseOnFocusLoss autoClose={2000} limit={2} />

      </div >
    </React.Fragment >
  );
};

export default Configuration;